
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HomeButtonsComponent extends Vue {
    root = this.$store.state.root;
}
